module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drawer drawer-right drawer-map-right dw-xs-10 fold",
    attrs: {
      "id": "drawer-truck-information",
      "aria-labelledby": "drawer-truck-information",
      "aria-expanded": "true"
    }
  }, [_c('div', {
    staticClass: "drawer-contents"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "drawer-body"
  }, [(_vm.get(_vm.value, 'load')) ? [_c('div', {
    staticClass: "thumb-left truck m-b-sm"
  }, [_c('img', {
    staticClass: "thumb",
    attrs: {
      "src": _vm.truck.url,
      "alt": "truck"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "m-b-none"
  }, [_vm._v(_vm._s(_vm.truck.company))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.truck.registration))])]), _vm._v(" "), _c('p', {
    staticClass: "text-muted small"
  }, [_vm._v("Location last updated " + _vm._s(_vm.get(_vm.value, 'location.age')) + ".")]), _vm._v(" "), _c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v(_vm._s(_vm.get(_vm.value, 'load.carrier.name')))]), _c('br'), _vm._v("\n          " + _vm._s(_vm.get(_vm.value, 'load.carrier.company'))), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-phone",
    style: ({
      visibility: _vm.get(_vm.value, 'load.carrier.mobile') ? 'visible' : 'hidden'
    })
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("tel:" + (_vm.get(_vm.value, 'load.carrier.mobile')))
    }
  }, [_vm._v(_vm._s(_vm.get(_vm.value, 'load.carrier.mobile')))])]), _vm._v(" "), _c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Base Location")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.truck.location) + "\n        ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "thumb-left m-b-md"
  }, [_c('img', {
    staticClass: "thumb",
    attrs: {
      "src": _vm.get(_vm.truck, 'driver.url')
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "m-b-none"
  }, [_vm._v(_vm._s(_vm.get(_vm.truck, 'driver.name')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-mobile"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("tel:" + (_vm.get(_vm.truck, 'driver.mobile')))
    }
  }, [_vm._v(_vm._s(_vm.get(_vm.truck, 'driver.mobile')))])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "job-details"
  }, [_c('h4', [_vm._v(_vm._s(_vm.get(_vm.value, 'load.job.client')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(((_vm.get(_vm.value, 'load.job.number')) + " - " + (_vm.get(_vm.value, 'load.job.quantity')) + "t " + (_vm.get(_vm.value, 'load.job.commodity.name')))))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "target": "_blank",
      "to": {
        name: 'loads.show',
        params: {
          id: _vm.get(_vm.value, 'load.id')
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])], 1), _vm._v(" "), _c('job-location', {
    attrs: {
      "location": _vm.get(_vm.value, 'load.from'),
      "title": "From"
    }
  }), _vm._v(" "), _c('job-location', {
    attrs: {
      "location": _vm.get(_vm.value, 'load.to'),
      "title": "To"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "target": "_blank",
      "to": {
        name: 'loads.show',
        params: {
          id: _vm.get(_vm.value, 'load.id')
        }
      }
    }
  }, [_vm._v("\n          View load history.\n        ")])] : [_c('div', {
    staticClass: "thumb-left m-b-md"
  }, [_c('img', {
    staticClass: "thumb",
    attrs: {
      "src": _vm.get(_vm.value, 'url'),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "m-b-none"
  }, [_vm._v(_vm._s(_vm.get(_vm.value, 'name')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-mobile",
    style: ({
      visibility: _vm.get(_vm.value, 'mobile') ? 'visible' : 'hidden'
    })
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("tel:" + (_vm.get(_vm.value, 'mobile')))
    }
  }, [_vm._v(_vm._s(_vm.get(_vm.value, 'mobile')))])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "text-muted small"
  }, [_vm._v("\n          Location last updated " + _vm._s(_vm.get(_vm.value, 'location.age')) + ".\n        ")]), _vm._v(" "), _c('h3', {
    staticClass: "m-b-sm m-t-lg"
  }, [_c('i', {
    staticClass: "fa fa-info-circle text-muted"
  }), _vm._v(" No Active Load")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "target": "_blank",
      "to": {
        name: 'loads.show',
        params: {
          id: _vm.get(_vm.value, 'load.id')
        }
      }
    }
  }, [_vm._v("\n          View load history.\n        ")])]], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drawer-heading"
  }, [_c('h3', {
    staticClass: "drawer-title"
  }, [_c('i', {
    staticClass: "fa fa-truck"
  }), _vm._v(" Truck Information\n        "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "href": "#drawer-truck-information",
      "data-toggle": "drawer",
      "aria-controls": "drawer-shortlist"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Primary Driver")]), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "m-b-md m-t-lg"
  }, [_c('i', {
    staticClass: "fa fa-info-circle text-muted"
  }), _vm._v(" Active Load Details")])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-d5757410"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/TruckDetails.vue
// module id = 1079
// module chunks = 0